import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { VetSchedulePlannerLandingComponent } from './landing/landing.component'

const routes: Routes = [
   {
      path: '',
      component: VetSchedulePlannerLandingComponent,
      data: { areaName: 'Vet Schedule Planner', breadcrumb: '' },
   },
   {
      path: ':practiceSKey',
      component: VetSchedulePlannerLandingComponent,
      data: { areaName: 'Vet Schedule Planner', breadcrumb: '' },
   },
   {
      path: ':practiceSKey/:weekStart',
      component: VetSchedulePlannerLandingComponent,
      data: { areaName: 'Vet Schedule Planner', breadcrumb: '' },
   },
]

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule],
})
export class VetSchedulePlannerRoutingModule {}
